import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
    selector: 'gtw-credits-part-iii-f8820',
    templateUrl: './credits-part-iii-f8820.component.html',
    styleUrls: ['./credits-part-iii-f8820.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CreditsPartIIIF8820Component {
  @Input() activeTab: string = '';
  @Input() currentFormHeader: any = null;
  @Input() tableHeader: any[] = [];
  @Input() outerList: any[] = [];
  @Input() formList: any[] = [];

  @Output() fieldChange = new EventEmitter<{ item: any; value: any }>();
  @Output() dateChange = new EventEmitter<{ item: any; event: Event }>();
  @Output() dateVariousChange = new EventEmitter<any>();
  @Output() radioToggle = new EventEmitter<{ item: any; checked: boolean }>();

  get partIRows(): any[] {
    return (this.outerList || []).filter((r: any) => r.IS_FORM_DISPLAY === 'Y' && r.PART_NO === 'I');
  }

  get partIIRows(): any[] {
    return (this.outerList || []).filter((r: any) => r.IS_FORM_DISPLAY === 'Y' && r.PART_NO === 'II');
  }

  getPartIInputs(lineKey: any): any[] {
    return (this.formList || []).filter(
      (x: any) => x.FORM_LINE_KEY === lineKey
        && x.IS_FORM_DISPLAY === 'Y'
        && x.EDIT_TYPE !== 'radio'
    );
  }

  getPartIRadios(lineKey: any): any[] {
    return (this.formList || []).filter(
      (x: any) => x.FORM_LINE_KEY === lineKey
        && x.IS_FORM_DISPLAY === 'Y'
        && x.EDIT_TYPE === 'radio'
    );
  }

  getPartIIEditableInputs(lineKey: any): any[] {
    return (this.formList || []).filter(
      (x: any) => x.FORM_LINE_KEY === lineKey
        && x.IS_FORM_DISPLAY === 'Y'
        && x.IS_EDITABLE_CELL === 'Y'
    );
  }

  toDateInputFormat(value: string): string {
    if (!value) return '';
    const parts = String(value).split('/');
    if (parts.length !== 3) return value;
    return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
  }

  onTextChange(item: any, event: any): void {
    const value = event?.target?.value ?? event;
    this.fieldChange.emit({ item, value });
  }

  onDateInputChange(item: any, event: Event): void {
    this.dateChange.emit({ item, event });
  }

  onDateVariousChange(item: any): void {
    this.dateVariousChange.emit(item);
  }

  onRadioToggle(item: any, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.radioToggle.emit({ item, checked });
  }

  trackByLineAttribKey(_: number, row: any): any {
    return row?.LINE_ATTRIB_KEY ?? row?.FORM_LINE_KEY ?? _;
  }
}
